/*
 创建者 魏强(2018.1.23)
 */
import axios from "axios";
import { getNowFormatDate, getSession } from "./tool";
import {
  GUEST_PATHS,
  MEMBER_PATHS,
  ORDER_PATHS,
  SETTLE_PATHS,
  TOKEN_PATHS,
  SETTLEMENT_PATHS,
  SETTLEMENT_HIGH,
  SELLER_PATH,
} from "./url";
import { encryptDes } from "./des";
import { Message } from "iview";
import store from "@/components/store";
import Router from "@/components/router/index";

// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  // timeout: 5000 // 请求超时时间
  withCredentials: true,
});

// request拦截器
// const isLocal = process.env.NODE_ENV !== 'production' // 区别本地和线上(测试和正式)
// const isProd = location.hostname === 'www.kxymall.com' // 区别测试和正式

service.interceptors.request.use(
  (config) => {
    // 这里可以加一些http头 如果有必要
    /*if (store.getters.token) {
    config.headers['Authorization'] = store.getters.token; // 让每个请求携带token--['X-Token']为自定义key 请根据实际情况自行修改
    }*/
    config.headers.sid = getSession("sid");

    let commonToken = {
      client: "PC",
      transeq: getNowFormatDate(),
      mac: "",
      product: "GDOMALL", // 产品类型（必传参数）
      accessSource: "PC", // 访问来源（必传参数）
      version: "1.0.0", //当前请求来源的版本号（必传参数）
      sid: getSession("sid"), // 结算返回的uid（登录状态必传参数）
    };
    if (config.url.indexOf("api/member/improveMemberInfo") !== -1) {
      config.headers.secretType = 2;
      config.headers.secretBody = true;
    }
    let method = config.method;
    // 检查该请求接口是否需要在header加请求头Auth-Token //判断商品删除接口是调用
    if (
      TOKEN_PATHS.includes(config.url.split("?")[0]) ||
      config.url.indexOf(TOKEN_PATHS[0]) !== -1
    ) {
      // 改了
      config.headers["Auth-Token"] = encryptDes(JSON.stringify(commonToken));
      //结算接口header加密
      // 改了
      if (method === "post" && !!!config.data.header) {
        // config.data.header = commonToken;
        config.headers["Auth-Token"] = encryptDes(JSON.stringify(commonToken));
      }
    } else if (
      SETTLEMENT_PATHS.includes(config.url.split("?")[0]) ||
      config.url.indexOf(SETTLEMENT_PATHS[0]) !== -1
    ) {
      config.headers["Auth-Token"] = encryptDes(JSON.stringify(commonToken));
    } else {
      // 改了
      if ((method === "post" || method === "get") && !!!config.data.header) {
        // config.data.header = commonToken;
        config.headers["Auth-Token"] = encryptDes(JSON.stringify(commonToken));
      }
    }

    let baseURL = "";
    if (GUEST_PATHS.includes(config.url.split("?")[0])) {
      // 检查该请求接口是否在白名单中
      baseURL = `${process.env.PROTOCOL}://${process.env.NO_CHECK_TOKEN_HOST}/`;
    } else if (SETTLEMENT_HIGH.includes(config.url.split("?")[0])) {
      baseURL = `${process.env.PROTOCOL}://${process.env.SETTLEMENT_HIGH}/`;
    } else if (SELLER_PATH.includes(config.url.split("?")[0])) {
      baseURL = `${process.env.SELLER_HOST}/`;
    } else {
      baseURL = `${process.env.PROTOCOL}://${process.env.CHECK_TOKEN_HOST}/`;
    }
    if (MEMBER_PATHS.includes(config.url.split("?")[0])) {
      // 检查该请求接口是否在会员信息中
      baseURL = `${process.env.PROTOCOL}://${process.env.MEMBER_HOST}/`;
    }
    if (ORDER_PATHS.includes(config.url.split("?")[0])) {
      // 检查该请求接口是否在订单信息中
      baseURL = `${process.env.PROTOCOL}://${process.env.ORDER_HOST}/`;
    }
    if (SETTLE_PATHS.includes(config.url.split("?")[0])) {
      // 检查该请求接口是否在结算中
      baseURL = `${process.env.PROTOCOL}://${process.env.SETTLE_HOST}/`;
    }

    if (SETTLEMENT_PATHS.includes(config.url.split("?")[0])) {
      // 检查该请求接口是否在重构的结算接口中
      baseURL = `${process.env.PROTOCOL}://${process.env.SETTLEMENT_HOST}/`;
    }

    config.baseURL = baseURL;

    return config;
  },
  (error) => {
    // for debug
    console.log(error);
    Promise.reject(error);
  }
);

// respone拦截器
service.interceptors.response.use(
  (response) => {
    /**
     * 下面的注释为通过response自定义code来标示请求状态，当code返回如下情况为权限有问题，登出并返回到登录页
     * 如通过xmlhttprequest 状态码标识 逻辑可写在下面error中
     */
    const res = response.data;
    if (res.resCode === 30) {
      // 需要重新登录
      setTimeout(function () {
        store
          .dispatch("LogOut", {})
          .then(() => {
            store.dispatch("cleanCartLogOut");
            localStorage.clear();
            sessionStorage.clear();
            if (Router.path === "/index") {
              window.history.go(0);
            }
          })
          .catch((err) => {});
      }, 1000);
    }
    if (res.resCode === 31) {
      // 在其他平台登录
      Message.warning(res.resDesc);
      setTimeout(function () {
        store
          .dispatch("LogOut", {})
          .then(() => {
            store.dispatch("cleanCartLogOut");
            localStorage.clear();
            sessionStorage.clear();
            Router.push("/login");
          })
          .catch((err) => {});
      }, 1000);
    }
    return response.data;
  },
  (error) => {
    console.log("err" + error); // for debug
    const data = error.response.data;
    // /*if(data.message==='权限过期'){

    //   }*/
    return Promise.reject(data);
  }
);

export default service;



// WEBPACK FOOTER //
// ./src/utils/fetch.js